import { ISortDirection, IUserSortBy } from 'graphql/types';

interface IInitialSort {
    field: IUserSortBy;
    direction: ISortDirection;
}

/** Parses the initial sort field and direction from URL search params. */
export const getInitialSortFromUrl = (): IInitialSort => {
    const searchParams = new URLSearchParams(window.location.search);
    const sortParam = searchParams.get('sortBy');

    const dirParam = searchParams.get('sortDir');

    if (
        sortParam &&
        Object.values(IUserSortBy).includes(sortParam as IUserSortBy)
    ) {
        const direction =
            dirParam &&
            Object.values(ISortDirection).includes(dirParam as ISortDirection)
                ? (dirParam as ISortDirection)
                : ISortDirection.Asc;

        return {
            field: sortParam as IUserSortBy,
            direction,
        };
    }

    return { field: IUserSortBy.Name, direction: ISortDirection.Asc };
};
